import { apiClient } from '../../../app/api/apiClient';
import type { AnalyticsFilters, AnalyticsSnapshot } from '../types/analytics.types';

export async function getAnalyticsOverview(filters: AnalyticsFilters = {}): Promise<AnalyticsSnapshot> {
  const response = await apiClient.get('/api/super-admin/analytics/overview', {
    query: filters as Record<string, string | number | boolean | undefined>,
  });
  return (response.data as { analytics: AnalyticsSnapshot }).analytics;
}
